// extracted by mini-css-extract-plugin
export var active = "_bv-2";
export var highlight = "_bv-1";
export var highlightLayer = "_bv-0";
export var issuePopover = "_bv-3";
export var statusIcon = "_bv-4";